import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const TrimsInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Trims Section"
    sectionKey="Trims"
    backRoute="/sections/trims"
  />
);

export default TrimsInternalTransfer;
